import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children"];
import React from 'react';
import { components } from 'react-select';
import Divider from '../../../general/Divider';
import classnames from 'classnames';
var _ref2 = /*#__PURE__*/React.createElement(Divider, null);
export default /*#__PURE__*/React.memo(function (_ref) {
  var _props$data;
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  var isSelected = props.isSelected;
  var _props$selectProps$op = props.selectProps.optionProps,
    className = _props$selectProps$op.className,
    override = _props$selectProps$op.override,
    optionFocusDisabledClassName = _props$selectProps$op.optionFocusDisabledClassName,
    isSelectAllFocused = _props$selectProps$op.isSelectAllFocused;
  return !(props !== null && props !== void 0 && (_props$data = props.data) !== null && _props$data !== void 0 && _props$data.divider) ? components.Option && /*#__PURE__*/React.createElement(components.Option, _extends({}, props, {
    className: classnames(className, _defineProperty({}, optionFocusDisabledClassName, isSelectAllFocused && !isSelected))
  }, override.option), children) : _ref2;
});